import { Component, EventEmitter, Input, Output, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { NomtrndistricenService } from "../nomservicios/nomtrndistricen.service";
import { Nomtrndistricen } from "../nominterfaces/nomtrndistricen";
import { isNullOrUndefined } from 'util';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';//CDPJ
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-nomtrndistricen',
  templateUrl: './nomtrndistricen.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class NomtrndistricenComponent implements OnInit, OnChanges {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;

  @Input() rucide: string;
  @Input() nomemp: string;
  @Input() detalle: any;
  @Input() strnum: string;
  @Output() salir = new EventEmitter<boolean>();

  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;
  oculto: boolean;
  largo: string;
  distriCCSelected: Nomtrndistricen

  public frameworkComponents;
  rowStyle;
  defaultColDefNomDistri;
  rowSelection = 'multiple';
  columnDefsNomDistri = [

    {
      headerName: 'CCostos', field: 'CEN_CODIGO', cellEditor: 'cellPrueba',
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 35,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Nombre', field: 'CEN_NOMBRE', width: 200, cellEditor: 'cellPrueba',
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 45
        }
      }
    },
    {
      headerName: 'Días', field: 'TRNDISCEN_DIAS', cellEditor: 'cellPrueba',
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
  ];
  constructor(public nomtrndistricenService: NomtrndistricenService, private datePipe: DatePipe,
    private messageService: MessageService, private auditoriagral: AuditoriagralService,
    private confirmationService: ConfirmationService, private init: NuevoComponentService, ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };

    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultColDefNomDistri = {
      editable: true,
      width: 100,
      objeto: 'nomdistricc'
    };
  }
  ngOnInit() {
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.oculto = true;

    this.largo = '500';
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
    for (const e in changes) {
      if (e === 'detalle' && this.detalle !== null && this.detalle !== undefined) {

        this.mostrarDistri();
      }
    }
  }
  manejarSenales(valor) {
    if (valor === 'Nuevo') {
      this.nuevo();
    }
    if (valor === 'Cancelar') {
      this.cancelar();
    }
    if (valor === 'Guardar') {
      this.guardarDistribucion()
    }
    if (valor === 'Borrar') {
      this.eliminar();
    }
    if (valor === 'Salir') {
      this.salir.emit(true);
    }
  }
  eliminar() {
    let intIndiceFila = 0
    if (this.distriCCSelected.TRNDISCEN_LINEA === 0) {
      intIndiceFila = this.nomtrndistricenService.nomdistribucionCC.findIndex(distri =>
        distri.CLAVE === this.distriCCSelected.CLAVE);
    } else {
      intIndiceFila = this.nomtrndistricenService.nomdistribucionCC.findIndex(distri =>
        distri.TRNDISCEN_LINEA === this.distriCCSelected.TRNDISCEN_LINEA);
    }
    let item: Nomtrndistricen;

    if (intIndiceFila !== -1) {
      item = this.nomtrndistricenService.nomdistribucionCC[intIndiceFila];
    } else {
      this.messageService.add({
        key: 'nomdistriCC',
        severity: 'error',
        summary: 'Error',
        detail: '! Seleccione una fila.... !'
      });
      return;
    }

    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'nomdistriCCconf',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        try {
          if (this.distriCCSelected.TRNDISCEN_LINEA === 0) {
            this.nomtrndistricenService.nomdistribucionCC.splice(intIndiceFila, 1);
            this.aggrid.refreshaggrid(this.nomtrndistricenService.nomdistribucionCC, this.defaultColDefNomDistri.objeto);
          } else {
            const rs=await this.nomtrndistricenService.getdetroldistri(item.ENCDISCEN_CODIGO,item.CEN_CODIGO);
            if (rs !== null && rs.length>0) {
              for (const iterator of rs) {
                if (iterator.NUMERO>0) {
                  this.messageService.add({
                    key: 'nomdistriCC',
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No se puede eliminar, porque está generada la distribución'
                  });
                  return;
                }
              }
            }
            await this.nomtrndistricenService.EliminarDistribucionCC(item).toPromise()//subscribe(data => {
            await this.auditoriagral.registrarAuditoria('NOM_TRNDISCEN', item.ENCDISCEN_CODIGO + '/' + item.CEN_CODIGO + '/' + item.EMP_CODIGO, 'E',
                '', '01', '', '', '', '').toPromise();

              this.nomtrndistricenService.nomdistribucionCC.splice(intIndiceFila,
                1);
              this.aggrid.refreshaggrid(this.nomtrndistricenService.nomdistribucionCC, this.defaultColDefNomDistri.objeto);
            //})

          }
          if (this.nomtrndistricenService.nomdistribucionCC.length > 0) {

            this.distriCCSelected = this.nomtrndistricenService.nomdistribucionCC[intIndiceFila - 1];
          };
        } catch (error) {
          this.messageService.add({
            key: 'nomdistriCC',
            severity: 'error',
            summary: 'Error',
            detail: 'Ocurrió un error al eliminar la línea'
          });
        }

      },
      reject: () => {
      }
    });
  }
  cancelar() {
    this.mostrarDistri();
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = false;
  }

  async guardarDistribucion() {
    let errores = 0;
    let intIndiceLista = 0;
    let item: Nomtrndistricen;
    for (intIndiceLista = 0; intIndiceLista < this.nomtrndistricenService.nomdistribucionCC.length; intIndiceLista++) {
      item = this.nomtrndistricenService.nomdistribucionCC[intIndiceLista];
      let cont = 0;
      const num = await this.nomtrndistricenService.validarcencodigo(item.CEN_CODIGO);
      if (num !== null && num !== undefined) {
        for (const rs of num) {
          if (rs.NUMERO !== null && rs.NUMERO !== undefined && rs.NUMERO !== '') {
            cont = rs.NUMERO
          }
        }
      }
      if (isNullOrUndefined(item.CEN_CODIGO) || item.CEN_CODIGO === '') {
        this.messageService.add({
          key: 'nomdistriCC',
          severity: 'error',
          summary: 'Información',
          detail: 'El CCostos no puede estar vacío'
        });
        return;
      }
      if (cont === 0) {
        this.messageService.add({
          key: 'nomdistriCC',
          severity: 'error',
          summary: 'Información',
          detail: 'El centro de costos ' + item.CEN_CODIGO + ' no existe'
        });
        return;
      }
      if (Number(item.TRNDISCEN_DIAS) === 0) { 
        this.messageService.add({
          key: 'nomdistriCC',
          severity: 'error',
          summary: 'Información',
          detail: 'No pueden haber días en cero '
        });
        return;
      }
      if (Number(this.nomtrndistricenService.total) > 30) {
        this.messageService.add({
          key: 'nomdistriCC',
          severity: 'error',
          summary: 'Información',
          detail: 'El total de la distribución no puede ser mayor a 30'
        });
        return;
      }
      if (isNullOrUndefined(item.TRNDISCEN_DIAS) || item.TRNDISCEN_DIAS === '') {
        this.messageService.add({
          key: 'nomdistriCC',
          severity: 'error',
          summary: 'Información',
          detail: 'El campo días no puede estar vacío'
        });
        return;
      }
    }
    for (intIndiceLista = 0; intIndiceLista < this.nomtrndistricenService.nomdistribucionCC.length; intIndiceLista++) {
      item = this.nomtrndistricenService.nomdistribucionCC[intIndiceLista];
      await this.nomtrndistricenService.guardardistribucion(item, this.detalle.DETDISCEN_LINEA)
      if (item.TRNDISCEN_LINEA === 0) {
        this.auditoriagral.registrarAuditoria('NOM_TRNDISCEN', item.ENCDISCEN_CODIGO + '/' + item.CEN_CODIGO + '/' + item.EMP_CODIGO, 'I',
          '', '01', '', '', '', '').subscribe()
      } else {
        this.auditoriagral.registrarAuditoria('NOM_TRNDISCEN', item.ENCDISCEN_CODIGO + '/' + item.CEN_CODIGO + '/' + item.EMP_CODIGO, 'A',
          '', '01', '', '', '', '').subscribe()
      }
    }
    this.messageService.add({
      key: 'nomdistriCC',
      severity: 'success',
      summary: 'Información',
      detail: 'Distribución guardada correctamente'
    });
    await this.cancelar()
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = false;
  }

  seleccionDistriCC(params) {
    if (params.object !== undefined) {
      this.distriCCSelected = params.object;
    }
  }
  nuevo() {
    const districc: Nomtrndistricen = {
      ENCDISCEN_CODIGO: this.strnum,
      EMP_CODIGO: this.detalle.EMP_CODIGO,
      CEN_CODIGO: '',
      CEN_NOMBRE: '',
      TRNDISCEN_DIAS: '0',
      CONTROL: '',
      TRNDISCEN_LINEA: 0
    };
    const indi = this.nomtrndistricenService.nomdistribucionCC.indexOf(this.distriCCSelected);

    if (indi === -1) {
      districc.CLAVE = '1' + this.datePipe.transform(new Date(), 'ddMMyyyyHHmmss');
      this.nomtrndistricenService.nomdistribucionCC.push(districc);
      this.distriCCSelected = districc;
      this.aggrid.refreshaggrid(this.nomtrndistricenService.nomdistribucionCC, this.defaultColDefNomDistri.objeto);
      this.aggrid.gridApi.setFocusedCell(0, 'CEN_CODIGO');
    } else {
      districc.CLAVE = (indi + 1) + '' + this.datePipe.transform(new Date(), 'ddMMyyyyHHmmss');
      this.nomtrndistricenService.nomdistribucionCC.splice(indi + 1, 0, districc);
      this.distriCCSelected = districc;
      this.aggrid.refreshaggridindex(this.nomtrndistricenService.nomdistribucionCC, this.defaultColDefNomDistri.objeto, indi);
      this.aggrid.gridApi.setFocusedCell(indi + 1, 'CEN_CODIGO');
    }
    this.botonesmodificar()
  }
  botonesmodificar() {
    this.botonNuevo = false;
    this.botonGuardar = false;
    this.botonBorrar = false;
    this.botonRegresar = false;
  }
  cambio(cambio) {
    if (cambio === true) {
      this.botonGuardar = false;
      this.botonRegresar = false;
      this.botonNuevo = false;
    }
  }
  mostrarDistri() {
    this.nomtrndistricenService.listardatos(this.strnum, this.detalle.EMP_CODIGO).subscribe(data => {
      this.nomtrndistricenService.nomdistribucionCC = data;
      for (const data of this.nomtrndistricenService.nomdistribucionCC) {

        this.distriCCSelected = data;
      }
      this.nomtrndistricenService.calcularTotal();
    });
  }
}
